
import { memo } from "react";
import { cn } from "@/lib/utils";

interface HectorLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
}

// Hector wordmark logo (single PNG asset), sized by height per `size`.
const HectorLogo = memo(({ className, size = "2xl" }: HectorLogoProps) => {
  const sizeClasses = {
    sm: "h-5",
    md: "h-6",
    lg: "h-8",
    xl: "h-10",
    "2xl": "h-12",
    "3xl": "h-14",
    "4xl": "h-16",
  };

  return (
    <img
      src="/logo_hector-black.png"
      alt="Hector"
      className={cn("w-auto", sizeClasses[size], className)}
    />
  );
});

HectorLogo.displayName = 'HectorLogo';

export default HectorLogo;
